const MonthlyCalendarStrings = {
  en: {
    calendar: {
      title: "Monthly Calendar",
      myBookings: "My Bookings",
      prevMonth: "← Prev",
      nextMonth: "Next →",
      today: "Today",
      ariaGoToToday: "Go to today",
      ariaPrevMonth: "Previous month",
      ariaNextMonth: "Next month",
    },
    monthNames: [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ],
    dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayStatus: {
      active: "Active",
      inactive: "Inactive",
      mixed: "Mixed",
      none: "No Slots",
    },
    legend: {
      title: "Legend",
      today: "Today",
      active: "Active",
      completed: "Completed",
      cancelled: "Cancelled",
    },
    details: {
      slotDetails: "Slot Details",
      course: "Slot",
      section: "Section",
      instructor: "Instructor",
      day: "Day",
      time: "Time",
      room: "Room",
      duration: "Duration",
      studentLimit: "Student Limit",
      startDate: "Start Date",
      endDate: "End Date",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      noSlotsSelected: "No slots found for this date",
    },
    bookingStatus: {
      completed: "Completed",
      cancelled: "Cancelled",
    },
    officeHours: "Office Hours",
  },
  ar: {
    calendar: {
      title: "التقويم الشهري",
      myBookings: "حجوزاتي",
      prevMonth: "→ الشهر السابق",
      nextMonth: "الشهر التالي ←",
      today: "اليوم",
      ariaGoToToday: "الانتقال إلى اليوم الحالي",
      ariaPrevMonth: "الشهر السابق",
      ariaNextMonth: "الشهر التالي",
    },
    monthNames: [
      "يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
      "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
    ],
    dayNames: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
    dayStatus: {
      active: "نشط",
      inactive: "غير نشط",
      mixed: "مختلط",
      none: "لا توجد مواعيد",
    },
    legend: {
      title: "مفتاح الرموز",
      today: "اليوم",
      active: "نشط",
      completed: "مكتمل",
      cancelled: "ملغي",
    },
    details: {
      slotDetails: "تفاصيل الموعد",
      course: "الموعد",
      section: "القسم",
      instructor: "المدرس",
      day: "اليوم",
      time: "الوقت",
      room: "المكان",
      duration: "المدة",
      studentLimit: "الحد الأقصى للطلاب",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      status: "الحالة",
      active: "نشط",
      inactive: "غير نشط",
      noSlotsSelected: "لا توجد مواعيد لهذا التاريخ",
    },
    bookingStatus: {
      completed: "مكتمل",
      cancelled: "ملغي",
    },
    officeHours: "الساعات المكتبية",
  },
};

export default MonthlyCalendarStrings;
